import React, { useState, useEffect, Suspense, lazy } from 'react';
import './Layout.css';

const PopupComponent = lazy(() => import('../Popup/PopupComponent'));

const Layout = ({ children }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [hasSeenNewsLetterPopup, setHasSeenNewsLetterPopup] = useState(
    localStorage.getItem('hasSeenNewsLetterPopup') === 'true'
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPopupOpen(true);
    }, 7000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Lighthouse flagged landmark-one-main on every page: the app rendered no
          <main> at all, so assistive tech had no way to skip to page content. */}
      <main>{children}</main>
      {isPopupOpen && !hasSeenNewsLetterPopup && (
        <Suspense fallback={null}>
          <PopupComponent
            className='popup'
            isOpen={isPopupOpen}
            setIsOpen={setIsPopupOpen}
            onAcknowledge={() => {
              localStorage.setItem('hasSeenNewsLetterPopup', 'true');
              setHasSeenNewsLetterPopup(true);
            }}
          />
        </Suspense>
      )}
    </>
  );
};

export default Layout;
